/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mijn PiE BFF
 * OpenAPI spec version: 1.0
 */

export type EnergyType = typeof EnergyType[keyof typeof EnergyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnergyType = {
  Electricity: 'Electricity',
  Gas: 'Gas',
} as const;
